export default __webpack_public_path__ + "static/media/11.9d340e5c.png";